import React from 'react';
import { DefaultToastContainer } from 'react-toast-notifications';
import type { ToastContainerProps } from './types';
import { TOAST_REGION_NAME } from './types';
import useToastContainer from './useToastContainer';

/**
 * ToastContainer — v2 molecule.
 *
 * The live region every toast is announced through. Registered once in
 * `src/App.js` with `components={{ Toast, ToastContainer }}`.
 *
 * The library keeps this container mounted for the whole life of the
 * `<ToastProvider>` and inserts each toast into it, so the region exists before
 * any message arrives. That is the point: a region created together with its
 * content produces no mutation for a screen reader to detect and is never
 * announced — hence the `aria-live` here and not in `Toast`.
 *
 * `aria-atomic="false"` overrides what `role="status"` implies, which would
 * reread the whole stack on every new toast.
 */
function ToastContainer(props: Readonly<ToastContainerProps>): JSX.Element {
  useToastContainer();

  return <DefaultToastContainer {...props} aria-atomic="false" aria-live="polite" data-toast-region={TOAST_REGION_NAME} role="status" />;
}

export default ToastContainer;
